export default function ScorePieChart({ average,averageText,lower,lowerText,higher,higherText }) {
    const width = 200;
    return (
        <div className="w-[200px] min-h-[200px] h-[200px] max-w-[200px] flex justify-center items-center mt-[40px]">
            <div style={{ width: width, height: width }} className="relative">
                <svg width={width} height={width} viewBox="0 0 200 200">
                    <circle cx="100" cy="100" r="80" stroke="#E0E0E0" strokeWidth="20" fill="none" />
                    <circle
                        cx="100"
                        cy="100"
                        r="80"
                        stroke="#1F4CC8"
                        strokeWidth="30"
                        fill="none"
                        strokeDasharray={`${average * 2 * Math.PI * 80}, ${2 * Math.PI * 80}`}
                        transform="rotate(-90 100 100)"
                    />
                    {lower>=0&&<line
                        x1="100"
                        y1="100"
                        x2={100 + 100 * Math.cos(2 * Math.PI * lower - Math.PI / 2)}
                        y2={100 + 100 * Math.sin(2 * Math.PI * lower - Math.PI / 2)}
                        stroke="#FF7961"
                        strokeWidth="5"
                    />}
                    {higher>=0&&<line
                        x1="100"
                        y1="100"
                        x2={100 + 100 * Math.cos(2 * Math.PI * higher - Math.PI / 2)}
                        y2={100 + 100 * Math.sin(2 * Math.PI * higher - Math.PI / 2)}
                        stroke="#00E9BA"
                        strokeWidth="5"
                    />}
                    <circle cx="100" cy="100" r="65" fill="white" strokeWidth="0" />
                </svg>
                <div className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-[13px] font-[700] text-[#999] text-center'>
                    平均分數:<br />
                    <div className="text-[42px] text-[#1F4CC8] mt-[-10px]">{averageText}</div>
                </div>
                {lower>=0&&<div
                    className="absolute"
                    style={{
                        top: `${100 + 120 * Math.sin(2 * Math.PI * lower - Math.PI / 2)}px`,
                        left: `${100 + 120 * Math.cos(2 * Math.PI * lower - Math.PI / 2)}px`,
                        transform: 'translate(-50%, -50%)',
                        color: '#FF7961',
                        fontSize: '15px',
                        fontWeight: 'bold',
                    }}
                >
                    {lowerText}
                </div>}
                {higher>=0&&<div
                    className="absolute"
                    style={{
                        top: `${100 + 120 * Math.sin(2 * Math.PI * higher - Math.PI / 2)}px`,
                        left: `${100 + 120 * Math.cos(2 * Math.PI * higher - Math.PI / 2)}px`,
                        transform: 'translate(-50%, -50%)',
                        color: '#00E9BA',
                        fontSize: '15px',
                        fontWeight: 'bold',
                    }}
                >
                    {higherText}
                </div>}
            </div>
        </div>
    )
}

